// services/notificationService.js
import axiosConfig from '../api/axiosConfig';

const notificationService = {
  // Tüm bildirimleri getir
  async getNotifications(params = {}) {
    try {
      const response = await axiosConfig.get('/admin/notifications', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  // Bildirimi okundu olarak işaretle
  async markAsRead(id) {
    try {
      const response = await axiosConfig.put(`/admin/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  // Tüm bildirimleri okundu olarak işaretle
  async markAllAsRead() {
    try {
      const response = await axiosConfig.put('/admin/notifications/mark-all-read');
      return response.data;
    } catch (error) {
      console.error('Error marking all as read:', error);
      throw error;
    }
  },

  // Bildirimi sil
  async deleteNotification(id) {
    try {
      const response = await axiosConfig.delete(`/admin/notifications/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  },

  // Eski bildirimleri temizle
  async clearOldNotifications() {
    try {
      const response = await axiosConfig.delete('/admin/notifications/clear/old');
      return response.data;
    } catch (error) {
      console.error('Error clearing old notifications:', error);
      throw error;
    }
  },

  // Yeni bildirim oluştur (test için)
  async createNotification(data) {
    try {
      const response = await axiosConfig.post('/admin/notifications', data);
      return response.data;
    } catch (error) {
      console.error('Error creating notification:', error);
      throw error;
    }
  }
};

export default notificationService;
